export * from './houseFeatureIds';

export const TRACKING_PAGE_TYPES = {
  SEARCH_PAGE: 'search',
  PRODUCT_PAGE: 'product_page',
  FAVORITES: 'favorites'
};

export const LIST_E_COMMERCE = {
  EXTRA_ROOMS: 'extra-rooms',
  SIMILAR_PROPERTIES: 'similar-properties'
};
